import { getAuditPendingCount } from '@/api/giftcard/audit'

const POLL_INTERVAL_MS = 10000

const auditReminder = {
  namespaced: true,
  state: {
    redeemPending: 0,
    withdrawPending: 0,
    loading: false
  },
  mutations: {
    SET_AUDIT_COUNTS(state, payload) {
      state.redeemPending = toCount(payload.redeemPending)
      state.withdrawPending = toCount(payload.withdrawPending)
    },
    SET_AUDIT_LOADING(state, loading) {
      state.loading = !!loading
    }
  },
  actions: {
    fetchAuditPendingCount({ commit }) {
      commit('SET_AUDIT_LOADING', true)
      return getAuditPendingCount().then(res => {
        const data = res.data || {}
        commit('SET_AUDIT_COUNTS', {
          redeemPending: data.redeemPendingCount,
          withdrawPending: data.withdrawPendingCount
        })
      }).catch(() => {
        // 静默失败
      }).finally(() => {
        commit('SET_AUDIT_LOADING', false)
      })
    }
  }
}

export default auditReminder
export { POLL_INTERVAL_MS }

function toCount(value) {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}
